
let initialized = false;
let isHealthy = true;

let resolveInit: () => void;
const initDone = new Promise<void>((res) => (resolveInit = res));

export function healthStatus() {
  return { initialized, isHealthy };
}

export function markHealth(ok: boolean) {
  isHealthy = ok;
  if (!initialized) {
    initialized = true;
    resolveInit();
  }
}

export async function waitUntilHealthChecked() {
  if (!initialized) {
    await initDone;
  }
}

export async function hasConnection() {
  await waitUntilHealthChecked();
  if (!isHealthy) {
    return false
  }
  return true
}
